import React from "react";
import { useBilling } from "../store/BillingContext";
import { DocumentTable } from "../components/documents/DocumentTable";

export const InvoicesView: React.FC = () => {
  const { state, setActiveDoc } = useBilling();

  return (
    <section className="panel">
      <div className="panel-title">
        <h3>All Tax Invoices ({state.invoices.length})</h3>
      </div>

      <DocumentTable docs={state.invoices} onEdit={setActiveDoc} />
    </section>
  );
};
